import { FC } from 'react'
import styles from './PropositionCardSkeleton.module.scss'

const PropositionCardSkeleton: FC = () => {
  return (
    <div className={styles['proposition-skeleton']}>
      <div className={styles.content}>
        <div className={styles.title}></div>
        <div className={styles.price}></div>
        <div className={styles.calculate}></div>
        <div className={styles.perks}>
          <div className={styles.line}></div>
          <div className={styles.line}></div>
          <div className={styles.line}></div>
          <div className={styles.line}></div>
        </div>
      </div>
      <div className={styles['transfer-now']}></div>
    </div>
  )
}

export default PropositionCardSkeleton
